import { ProjectThemeData } from './project-theme-data';
import { useEffect, useState } from 'react';
import { useYoProjectsSnapshots } from '@yakoffice/yakoffice-firebase';
import { determineIfPublisherProjectId } from '@yakoffice/helpers';
import { defaultThemeColor } from './default-theme';

export const useProjectTheme = (_projectId?: string): ProjectThemeData => {

    const [projectTheme, setProjectTheme] = useState<ProjectThemeData>(new ProjectThemeData(defaultThemeColor));
    const { yoProjects, error: yoProjectsError } = useYoProjectsSnapshots();

    useEffect(() => {

        if (yoProjectsError === null) {

            if (yoProjects.length > 0) {

                if (_projectId !== undefined && _projectId !== null) {

                    const projectId = determineIfPublisherProjectId(_projectId);

                    const project = yoProjects.find(project => project.id.toLowerCase() === projectId.toLocaleLowerCase());

                    if (project !== undefined) {
                        setProjectTheme(new ProjectThemeData(project.color));

                        const body = document.getElementById('body');

                        if (project.color !== null || project.color !== undefined || project.color !== '') {
                            body?.classList.add(project.color);
                        } else
                            body?.classList.add(defaultThemeColor);
                    }
                }
            }
        }
    }, [_projectId, yoProjectsError, yoProjects]);

    return projectTheme;
};
